import { render, staticRenderFns } from "./modalDashboard.vue?vue&type=template&id=cb7117ee"
import script from "./modalDashboard.vue?vue&type=script&lang=js"
export * from "./modalDashboard.vue?vue&type=script&lang=js"
import style0 from "./modalDashboard.vue?vue&type=style&index=0&id=cb7117ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports